import React from "react";
import ListOfPatientTable from "../../../components/doctor-side-components/patients-table/PatientsTable";

const DoctorPatientslisting = () => {
  return (
    <div className="p-4 ">
      <ListOfPatientTable />
    </div>
  );
};

export default DoctorPatientslisting;
